/*********************************************************************
 * The Initial Developer of the content of this file is NETCONOMY.
 * All portions of the code written by NETCONOMY are property of
 * NETCONOMY. All Rights Reserved.
 *
 * NETCONOMY Software & Consulting GmbH
 * Hilmgasse 4, A-8010 Graz (Austria)
 * FN 204360 f, Landesgericht fuer ZRS Graz
 * Tel: +43 (316) 815 544
 * Fax: +43 (316) 815544-99
 * www.netconomy.net
 *
 * (c) 2022 by NETCONOMY Software & Consulting GmbH
 *********************************************************************/

const fileHelpers = {
    readFileSize: number => {
        if (number < 1024) {
            return {size: number, unit: 'bytes', realSize: number};
        } else if (number >= 1024 && number < 1048576) {
            return {size: (number / 1024).toFixed(1), unit: 'KB', realSize: number};
        } else if (number >= 1048576) {
            return {size: (number / 1048576).toFixed(1), unit: 'MB', realSize: number};
        }
    }
}

export default fileHelpers;